module.exports = __webpack_public_path__ + "img/bg.adef25a4.png";